import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { Loader, Center, Stack, Text } from '@mantine/core';

/**
 * AdminRoute - Route guard for admin users only
 *
 * Requires authentication AND admin role
 * Sprint 041: Redirects to / (marketing homepage) if not authenticated
 * Redirects to /access-denied if authenticated but not admin
 */
export const AdminRoute: React.FC = (): React.ReactElement => {
  const { isAuthenticated, isAdmin, isLoading } = useAuth();

  console.log('[AdminRoute] Auth state:', { isAuthenticated, isAdmin, isLoading });

  // Show loading state while checking authentication
  if (isLoading) {
    console.log('[AdminRoute] ⏳ Loading, showing spinner...');
    return (
      <Center h="100vh">
        <Stack align="center" gap="md">
          <Loader size="lg" />
          <Text size="sm" c="dimmed">
            Loading...
          </Text>
        </Stack>
      </Center>
    );
  }

  // Sprint 041: Redirect to home page (which has Login button) if not authenticated
  if (!isAuthenticated) {
    console.log('[AdminRoute] ❌ Not authenticated, redirecting to home');
    return <Navigate to="/" replace />;
  }

  // Redirect to access denied if not admin
  if (!isAdmin) {
    console.log('[AdminRoute] ❌ Not an admin, redirecting to access-denied');
    return <Navigate to="/access-denied" replace />;
  }

  console.log('[AdminRoute] ✅ Authenticated as admin, rendering routes');
  // Render child routes
  return <Outlet />;
};
